import { render, staticRenderFns } from "./GenderView.vue?vue&type=template&id=da080aa0"
import script from "./GenderView.vue?vue&type=script&lang=js"
export * from "./GenderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports